<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import URL from '@/views/mis/util/url'
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import download from '@/utils/download'
  let dataType = {"1":"LP名单","2":"未完成开户","3":"提交开户提醒","4":"订阅信息","5":"客户留言"};
  let driverType = {"1":"PC","2":"M","3":"APP"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM
    },
    created(){
        this.formData.cols = [
            { title: window.$t('mis.common.startTime'), field: 'startTime',type:5},
            { title: window.$t('mis.common.endTime'), field: 'endTime',type:5},
            { title: window.$t('mis.registerLog.dataType'), field: 'dataType',type:2,optionList:dataType,isNumber:true},
            { title: window.$t('mis.common.phone'), field: 'phone'},
            { title: 'IP', field: 'ip'},
            { title: window.$t('mis.registerLog.driverType'), field: 'driverType',type:2,optionList:driverType,isNumber:true},
            { title: window.$t('mis.registerLog.utmSource'), field: 'utmSource'},
            { title: window.$t('mis.registerLog.utmMedium'), field: 'utmMedium'},
            { title: window.$t('mis.registerLog.utmCampaign'), field: 'utmCampaign'},
            { title: window.$t('mis.registerLog.utmContent'), field: 'utmContent'},
            { title: window.$t('mis.registerLog.utmTerm'), field: 'utmTerm'},
            {click:window.$t('mis.bt.search')},
            {click:window.$t('mis.bt.down')},
            {click:window.$t('mis.bt.export')},
        ];
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('mis.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if(window.$t('mis.bt.down') == clickName){
            //隐藏关键字段
            const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
            download.exportExcel(URL.registeruserlog.down,param,window.$t('mis.registerLog.register'));
        }else if(window.$t('mis.bt.export') == clickName){
            const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
            download.exportExcel(URL.registeruserlog.down,param,window.$t('mis.registerLog.register'));
        }
      },
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.registeruserlog.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('mis.common.phone'), field: 'phone'},
              { title: window.$t('mis.registerLog.dataType'), field: 'dataType',render:(data)=>{
                  return dataType[data];
                  }},
              { title: window.$t('mis.registerLog.driverType'), field: 'driverType',render:(data)=>{
                  return driverType[data];
                  }},
              { title: 'IP', field: 'ip'},
              { title: window.$t('mis.registerLog.ipAddress'), field: 'ipAddress'},
              { title: window.$t('mis.registerLog.href'), field: 'href'},
              { title: window.$t('mis.registerLog.referrer'), field: 'referrer'},
              { title: window.$t('mis.registerLog.utmSource'), field: 'utmSource'},
              { title: window.$t('mis.registerLog.utmMedium'), field: 'utmMedium'},
              { title: window.$t('mis.registerLog.utmCampaign'), field: 'utmCampaign'},
              { title: window.$t('mis.registerLog.utmContent'), field: 'utmContent'},
              { title: window.$t('mis.registerLog.utmTerm'), field: 'utmTerm'},
              { title: window.$t('mis.common.email'), field: 'email'},
              { title: window.$t('mis.common.createTime'), field: 'createTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('mis.common.updateTime'), field: 'updateTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('mis.common.name'), field: 'userName'},
              { title: window.$t('mis.registerLog.directPhone'), field: 'directPhone'},
              { title: window.$t('mis.registerLog.phonePre'), field: 'phonePre'},
              { title: window.$t('mis.registerLog.title'), field: 'title'},
              { title: window.$t('mis.registerLog.businessType'), field: 'businessType'},
              { title: window.$t('mis.registerLog.ruleId'), field: 'ruleId'},
          ]
        }
      }
    }
  }
</script>
